import { createElement } from 'react';
import SelectField from 'material-ui/SelectField';

import { field } from './MaterialSelectField.less';

const MaterialSelectField = ({ children, ...other }) =>
  createElement(SelectField, { className: field, ...other }, children);

export default MaterialSelectField;
